'use client';
import { useTranslations } from 'next-intl';
import { useInView } from '@/hooks/useInView';
import type { Event_Entry } from '@/types/graphql';
import { getShouldDisplayPurchaseButton } from '@/utils/show';
import ShowDateTime from '../ShowDateTime';
import ShowPurchaseButton from './ShowPurchaseButton';
import StickyShowPurchaseBar from './StickyShowPurchaseBar';

interface Props {
    event: Event_Entry;
    price: string | null;
    venue: string | null;
    locale: string;
}

export default function PurchaseSectionWithStickyBar({ event, price, venue, locale }: Props) {
    const t = useTranslations('ShowPurchaseButton');
    const [ref, inView] = useInView<HTMLDivElement>({ threshold: 0.1 });

    return (
        <>
            <div ref={ref}>
                <div className="flex flex-col gap-y-4 bg-haug-ivory-30 p-4">
                    <div className="flex min-h-8 items-start justify-between gap-y-4 font-bold font-neue-haas text-sm uppercase">
                        <div>
                            <ShowDateTime event={event} locale={locale} />
                        </div>
                        <div className="md:text-center">{venue}</div>
                        {price && getShouldDisplayPurchaseButton(event) && (
                            <div className="md:text-right">
                                {t('price')}: {price}
                            </div>
                        )}
                    </div>
                    <ShowPurchaseButton event={event} />
                </div>
            </div>
            {getShouldDisplayPurchaseButton(event) && (
                <StickyShowPurchaseBar event={event} price={price} show={!inView} locale={locale} />
            )}
        </>
    );
}
